module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic05.d4bd97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic05.png
// module id = 602
// module chunks = 1